export const ItemType = Object.freeze({
	Badge: 'Badge',
	Group: 'Group',
	Search: 'Search',
});
